import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Portfolio from './components/Portfolio';
import Process from './components/Process';
import Contact from './components/Contact';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';

export default function Home() {
  return (
    <main className="bg-black min-h-screen relative">
      {/* Logo watermark — fijo en pantalla, estático mientras bajas */}
      <div
        aria-hidden="true"
        style={{
          position: 'fixed',
          inset: 0,
          zIndex: 2,
          pointerEvents: 'none',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden',
        }}
      >
        <img
          src="https://storage.readdy-site.link/project_files/56c71ce7-2f1f-4dce-9c8c-f4142bab2e5c/1fd83b18-d22c-4816-a3f6-91960f34a688_Recurso-1.png?v=96d66ea4a02ae16ed610d3eab4f0d8d7"
          alt=""
          style={{
            width: '90vw',
            maxWidth: 'none',
            height: 'auto',
            opacity: 0.07,
            userSelect: 'none',
            pointerEvents: 'none',
          }}
        />
      </div>
      <Navbar />
      <Hero />
      <About />
      <Services />
      <Portfolio />
      <Process />
      <Contact />
      <Footer />
      <WhatsAppButton />
    </main>
  );
}
